import AssetCharges from '@components/asset/AssetCharges'
import View from '@components/View'
import { useParams } from 'react-router-dom'

const AssetServiceView = () => {
  const params = useParams()

  return (
    <View title="Service">
      <AssetCharges
        assetCompanyID={parseInt(params.companyID)}
        assetID={params.assetID}
        type="S"
      />
    </View>
  )
}

export default AssetServiceView
